import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-two-arrow-down",
  "use": "icon-si-glyph-two-arrow-down-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-two-arrow-down\" id=\"icon-si-glyph-two-arrow-down\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1117</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(3.000000, 0.000000)\" fill=\"#434343\">\n            <path d=\"M5.002,11.854 L0.008,8.109 L0.008,12.049 L5.002,15.992 L9.967,11.95 L9.967,8.032 L9.955,8.021 L5.002,11.854 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M5.002,4.07 L0.008,0.119 L0.008,4.058 L5.002,8.023 L9.967,3.959 L9.967,0.041 L9.955,0.031 L5.002,4.07 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-two-arrow-down.svg
// module id = RQLV
// module chunks = 62